<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="employeeNo" label="员工工号">
              <a-input v-model:value="queryForm.employeeNo" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item name="roadAreaCode" label="路区代码">
              <a-input v-model:value="queryForm.roadAreaCode" allowClear placeholder="请输入"/>
            </dc-form-item>
          </a-form>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { reactive, ref, computed } from 'vue'
import { getRoadAreaList } from '@/api/yuntuSales/roadAreaCode'

const tableRef = ref()
const queryForm = reactive({
  roadAreaCode: '',
  employeeNo: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await getRoadAreaList(params)
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  {
    title: '路区代码',
    dataIndex: 'roadAreaCode'
  },
  {
    title: '员工名称',
    dataIndex: 'userName'
  },
  {
    title: '员工工号',
    dataIndex: 'employeeNo'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuRoadAreaCode' }
</script>

<style scoped></style>
